import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import { arrayX } from 'shared/data/tooltips';

const ArrayX = (props) => {
  const name = 'array_x';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    groupName,
    className,
    inputClassName,
    tooltip,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      value={parameters[name] || ''}
      onChange={onChange}
      tooltip={tooltip}
      groupName={groupName}
      errorMessage={errorMessage}
      inputId={inputId}
      required={required}
      type="number"
      className={className}
      inputClassName={inputClassName} />
  );
};

ArrayX.defaultProps = {
  label: 'Array Overall Length (inches)',
  tooltip: arrayX,
};

export default ArrayX;
